function anchorAttributes() {
  $('nav.menu--main .parent-menu a').each(function (){
    var text = $(this).text();
    $(this).attr({
      'data-event-category': 'Header',
      'data-event-action': 'Click',
      'data-event-label': text,
    });
  });

  $('a#home-button, a#home-button > img').attr({
    'data-event-category': 'Header',
    'data-event-action': 'Click',
    'data-event-label': 'Home',
  });

  $('article[about="/home"] article[about="/hyperkaliaemie-verstehen"] a.arrow-link').attr({
    'data-event-category': 'Internal Link Click',
    'data-event-action': '/',
    'data-event-label': 'Hyperkaliamie Verstehen',
  });
  $('article[about="/home"] article[about="/hyperkaliaemie-ursachen"] a.arrow-link').attr({
    'data-event-category': 'Internal Link Click',
    'data-event-action': '/',
    'data-event-label': 'Hyperkaliamie Ursachen',
  });
  $('article[about="/home"] article[about="/hyperkaliaemie-behandeln"] a.arrow-link').attr({
    'data-event-category': 'Internal Link Click',
    'data-event-action': '/',
    'data-event-label': 'Hyperkaliamie Behanein',
  });
  $('article[about="/home"] article[about="/tipps-angehoerige"] a.arrow-link').attr({
    'data-event-category': 'Internal Link Click',
    'data-event-action': '/',
    'data-event-label': 'Tipps Fur Angehorige',
  });

  $('article[about="/kalium/ernaehrung/kaliumarme-rezepte"] #download_file_1 a').attr({
    'data-event-category': 'PDF Download',
    'data-event-action': '/kalium/ernaehrung/kaliumarme-rezepte',
    'data-event-label': 'Rezept Gefüllte Paprika mit Pute',
  });
  $('article[about="/kalium/ernaehrung/kaliumarme-rezepte"] #download_file_2 a').attr({
    'data-event-category': 'PDF Download',
    'data-event-action': '/kalium/ernaehrung/kaliumarme-rezepte',
    'data-event-label': 'Rezept Frühstücksomelett',
  });
  $('article[about="/kalium/ernaehrung/kaliumarme-rezepte"] #download_file_3 a').attr({
    'data-event-category': 'PDF Download',
    'data-event-action': '/kalium/ernaehrung/kaliumarme-rezepte',
    'data-event-label': 'Rezept Pasta Mit Krauter-Knoblauch-Pesto',
  });
  $('article[about="/kalium/ernaehrung/kaliumarme-rezepte"] #download_file_4 a').attr({
    'data-event-category': 'PDF Download',
    'data-event-action': '/kalium/ernaehrung/kaliumarme-rezepte',
    'data-event-label': 'Rezept Hähnchenspieße auf orientalische Art',
  });
  $('article[about="/kalium/ernaehrung/kaliumarme-rezepte"] #download_file_5 a').attr({
    'data-event-category': 'PDF Download',
    'data-event-action': '/kalium/ernaehrung/kaliumarme-rezepte',
    'data-event-label': 'Rezept Himbeer-Baiser-Schneegestöber',
  });
  $('#footer-logo-link-1, #footer-logo-1').attr({
    'data-event-category': 'External Link Click',
    'data-event-action': '{{Page Path}}',
    'data-event-label': 'https://www.viforpharma.com/',
  });
  $('#footer-logo-link-2, #footer-logo-2').attr({
    'data-event-category': 'External Link Click',
    'data-event-action': '{{Page Path}}',
    'data-event-label': 'https://check-dein-eisen.ch/',
  });
  $('#footer-logo-link-3, #footer-logo-3').attr({
    'data-event-category': 'External Link Click',
    'data-event-action': '{{Page Path}}',
    'data-event-label': 'https://www.viforpharma.de/',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(1) > span').attr({
    'data-event-category': 'Footer',
    'data-event-action': 'Click',
    'data-event-label': 'Cookie Preferences',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(2) > a').attr({
    'data-event-category': 'Footer',
    'data-event-action': 'Click',
    'data-event-label': 'Datenschutz',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(3) > a').attr({
    'data-event-category': 'Footer',
    'data-event-action': 'Click',
    'data-event-label': 'Disclaimer',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(4) > a').attr({
    'data-event-category': 'Footer',
    'data-event-action': 'Click',
    'data-event-label': 'Impressum',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(5) > a').attr({
    'data-event-category': 'Footer',
    'data-event-action': 'Click',
    'data-event-label': 'Bildquellen',
  });
  $('nav.menu--footer div.content > ul > li:nth-child(6) > a').attr({
    'data-event-category': 'External Link Click',
    'data-event-action': '{{Page Path}}',
    'data-event-label': 'EisenNetzwerk',
  });

  $('[data-event-action="{{Page Path}}"]').attr('data-event-action', window.location.pathname);
}
